import { startOfWeekMonday, toLocalDateString } from '@/lib/utils';

interface WeeklyPoint {
  weekStartDate: string;
  collected: number;
}

/**
 * Week-on-week change between the last two complete weeks. The week containing
 * `today` is still in progress, so comparing it against a full week would read
 * as a large drop for most of the week.
 */
export function completeWeekTrendPct(points: readonly WeeklyPoint[], today: Date = new Date()): number | null {
  const currentWeekStart = toLocalDateString(startOfWeekMonday(today));
  const completeWeeks = points.filter((x) => x.weekStartDate.split('T')[0] < currentWeekStart);
  if (completeWeeks.length < 2) return null;

  const current = completeWeeks[completeWeeks.length - 1].collected;
  const previous = completeWeeks[completeWeeks.length - 2].collected;
  if (previous === 0) return null;

  return Math.round(((current - previous) / previous) * 1000) / 10;
}
